var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 17C11.3999 17 8.88095 19.6829 8.88095 23C8.88095 23.5523 8.45989 24 7.94048 24C7.42107 24 7 23.5523 7 23C7 18.5851 10.3547 15 14.5 15C18.6453 15 22 18.5851 22 23C22 23.5523 21.5789 24 21.0595 24C20.5401 24 20.119 23.5523 20.119 23C20.119 19.6829 17.6001 17 14.5 17Z",
    fill: "#0D64A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6.8C13.0148 6.8 11.8052 8.00576 11.8052 9.5C11.8052 10.9942 13.0148 12.2 14.5 12.2C15.9852 12.2 17.1948 10.9942 17.1948 9.5C17.1948 8.00576 15.9852 6.8 14.5 6.8ZM10 9.5C10 7.01779 12.0116 5 14.5 5C16.9884 5 19 7.01779 19 9.5C19 11.9822 16.9884 14 14.5 14C12.0116 14 10 11.9822 10 9.5Z",
    fill: "#0D64A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e719a779901f8d6d6acb0cd1b44e7634.svg";
export { ForwardRef as ReactComponent };